const isHandlerEnabled = (config = {}) => {
  return config.hasOwnProperty("handlerEnabled") && !config.handlerEnabled
    ? false
    : true;
};

/**
 * adding custom logic on 401, 429 responses to api requests
 * unauthorized api request - logout the user and redirect to sso
 * this custom handler can be bypassed on any specific request
 * by adding to the config {handlerEnabled: false}
 * @param {*} error
 */
export const ApiErrorHandler = (error, logout) => {
  if (
    isHandlerEnabled(error.config) &&
    error.response &&
    error.response.status
  ) {
    switch (error.response.status) {
      case 401:
        //TODO - log unauthorized access to a system such as sentry
        //window.Sentry.captureException(error);
        logout({ warningMsg: "UNAUTHORIZED_API" });
        break;
      case 403:
        logout({ warningMsg: "FORBIDDEN_API" });
        break;
      case 429:
        logout({ warningMsg: "CONCURRENT_SESSIONS" });
        break;
      default:
        break;
    }
  }
  return Promise.reject({ ...error });
};
